import { useEffect, useState } from 'react';
import { StanButton, StanDropdown } from '@/components';
import AdyenLogo from '@/assets/icons/payments/adyen.svg';
import USFlag from '@/assets/images/flag/us.webp';
import CAFlag from '@/assets/images/flag/ca.webp';

// Adyen is currently limited to US and Canada only
const ADYEN_SUPPORTED_COUNTRIES = [
    { code: 'US', name: 'United States', image: USFlag },
    { code: 'CA', name: 'Canada', image: CAFlag },
];

interface AdyenAccountConnectProps {
    onConnect: (country: string) => void;
    standard?: boolean;
}

export const AdyenAccountConnect = ({ onConnect, standard = false }: AdyenAccountConnectProps) => {
    const [country, setCountry] = useState('US');
    const [processing, setProcessing] = useState(false);

    // For standard, auto-connect
    useEffect(() => {
        if (standard) {
            handleConnect();
        }
    }, [standard]);

    const handleConnect = () => {
        setProcessing(true);
        onConnect(country);
    };

    return (
        <div className='bg-bg-canvas h-svh overflow-y-auto'>
            <div className='flex min-h-full flex-col justify-center py-8'>
                <div className='container mx-auto flex flex-col px-4'>
                    <AdyenLogo className='mx-auto max-w-sm' />

                    <div className='mt-16 text-center'>
                        <h2 className='text-heading-h2 font-bold'>Start Selling & Get Paid</h2>
                        <p className='text-body-sm text-gray mx-auto mt-4 max-w-xl'>
                            Stan partners with Adyen for payment processing.
                        </p>
                    </div>
                </div>

                <div className='container mx-auto mt-6 max-w-md px-4 text-center'>
                    {!standard && (
                        <div className='mb-6 text-left'>
                            <label className='text-body-sm mb-2 block font-bold'>Home Country</label>
                            <StanDropdown
                                id='country-select'
                                name='country'
                                options={ADYEN_SUPPORTED_COUNTRIES.map(c => ({
                                    label: c.name,
                                    value: c.code,
                                    icon: c.image,
                                }))}
                                currentValue={{
                                    label:
                                        ADYEN_SUPPORTED_COUNTRIES.find(c => c.code === country)?.name ||
                                        'United States',
                                    value: country,
                                }}
                                onSelect={value => setCountry(value.value)}
                                placeholder='Select country'
                            />
                        </div>
                    )}

                    <StanButton
                        name='adyen-connect-button'
                        className='w-full'
                        loading={processing}
                        disabled={!country || processing}
                        onClick={handleConnect}
                    >
                        Create My Stan Adyen Account
                    </StanButton>

                    <p className='text-caption-1-regular text-gray mt-2'>
                        You will be redirected to connect.adyen.com.
                    </p>
                </div>
            </div>
        </div>
    );
};
